export default "__VITE_ASSET__QxtAnDPi__"